import React from "react";
import FW from "../../../config/word.json";

export let homeBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    label: "ホーム",
    icon: <img src="/images/icons/home_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/home.svg" alt="" />,
  },
];
export let logOutBar = [
  //　ログアウト
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    label: "logout",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];
export let approvalGroupBar = [
  {
    title: FW.F_W_HOME_ApprovalList,
    path: "/approvallist",
  },
  {
    title: FW.F_W_HOME_ApprovaledList,
    path: "/approvaledlist",
  },
  {
    title: FW.F_W_HOME_RejectList,
    path: "/rejectedlist",
  },
];

export let SideBarForPCItems = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    label: "ホーム",
    icon: <img src="/images/icons/home_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/home.svg" alt="" />,
  },

  //　参会情報
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfo",
    label: "joinInfo",
    icon: <img src="/images/icons/user.svg" alt="" />,
    clickedIcon: <img src="/images/icons/user_active.svg" alt="" />,
  },

  //　大会管理
  {
    title: "大会管理",
    path: "/daikaiManage",
    label: "daikaiManage",
    icon: <img src="/images/icons/calendar-alt.svg" alt="" />,
    clickedIcon: <img src="/images/icons/calendar-alt-active.svg" alt="" />,
  },

  //　ファン情報
  {
    title: FW.F_W_HOME_FAN,
    path: "/fans",
    label: "fans",
    icon: <img src="/images/icons/fans.svg" alt="" />,
    clickedIcon: <img src="/images/icons/fans_active.svg" alt="" />,
  },

  //　ファン統計
  {
    title: FW.F_W_HOME_FANCOUNT,
    path: "/countFans",
    label: "countFans",
    icon: <img src="/images/icons/count.svg" alt="" />,
    clickedIcon: <img src="/images/icons/count_active.svg" alt="" />,
  },
  //　広告統計
  {
    title: "広告統計",
    path: "/adDisplayInfo",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
  //　広告一覧
  {
    title: "広告一覧",
    path: "/adList",
    icon: (
      <img
        src="/assets/icons/ad-list.svg"
        alt="広告一覧"
        style={{ width: "20px", height: "20px" }}
      />
    ),
  },

  //　データ移行
  {
    title: "データ移行",
    path: "/dataIko",
    label: "dataIko",
    icon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
  },

  //　ログアウト
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    label: "logout",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];

export let SideBarForPCItemsForGuest_8 = [
  //　参会情報(ゲスト用)
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfoForGuest",
    label: "joinInfo",
    icon: <img src="/images/icons/user.svg" alt="" />,
    clickedIcon: <img src="/images/icons/user_active.svg" alt="" />,
  },

  //　ログアウト
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    label: "logout",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];

export let SideBarForPCItemsForGuest_7 = [
  //　広告(ゲスト用)
  {
    title: "広告数字統計",
    path: "/dashboard",
    label: "dashboard",
    icon: <img src="/images/icons/user.svg" alt="" />,
    clickedIcon: <img src="/images/icons/user_active.svg" alt="" />,
  },

  //　ログアウト
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    label: "logout",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];
